import React from 'react';
import {Link} from 'react-router-dom';

const LOGO_SRC = `${process.env.PUBLIC_URL}/assets/images/resources/stricky-logo.png`;

export default class LogoBlack extends React.Component {
    render(){
        return (
            <>
                <div className="logo">
                    <Link to={process.env.PUBLIC_URL + `/`}>
                        <img src={LOGO_SRC} alt="SKV Industries" />
                    </Link>
                </div>
            </>
        )
    }
}
